export const createContestsEditionsRequests = (client) => ({
    listContestsEditions: async (params) => {
        const { data, meta, links } = await client.api.get("contests_editions", {
            params: params,
        });
        return { data, meta, links };
    },
    findContestsEdition: async (params) => {
        const { data } = await client.api.get(`contests_editions/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    contestsEditionChecklist: async (params) => {
        const response = await client.api.request({
            type: "contests_edition",
            method: "GET",
            url: `/contests_editions/${params?.id}/checklist`,
            params: params,
        });
        return response;
    },
    createContestsEdition: async (payload) => {
        const { data } = await client.api.create("contests_editions", payload);
        return { data };
    },
    updateContestsEdition: async (payload) => {
        const { data } = await client.api.update("contests_editions", payload);
        return { data };
    },
    publishContestsEdition: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload?.contestsEditionId}/publish`,
            body: payload,
            method: "POST",
        });
        return { data };
    },
    undoPublication: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload?.contestsEditionId}/unpublish`,
            body: payload,
            method: "POST",
        });
        return { data };
    },
    finishContestsEdition: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload?.contestsEditionId}/finish`,
            body: payload,
            method: "POST",
        });
        return { data };
    },
    publishAllScoresheets: async (payload) => {
        return await client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload?.contestsEditionId}/publish_scoresheets`,
            body: payload,
            method: "POST",
        });
    },
    getContestsEditionStats: (payload) => {
        return client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload.contestsEditionId}/stats`,
            method: "GET",
        });
    },
    getPublishingProgress: (payload) => {
        return client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload.contestsEditionId}/publishing_progress`,
            method: "GET",
        });
    },
    generateContestsEditionReport: async (payload) => {
        const res = await client.api.request({
            type: "contests_editions",
            url: `${client.getApiUrl()}/contests_editions/${payload?.id}/report`,
            body: payload,
            method: "POST",
        });
        return res?.data;
    },
    deleteContestsEdition: async (payload) => {
        const { data } = await client.api.delete("contests_editions", payload?.id);
        return { data };
    },
    toggleGoogleSheetSync: async (payload) => {
        const { data } = await client.axios.request({
            method: "PUT",
            url: `/contests_editions/${payload?.id}/google_sheet_sync`,
            data: { enabled: payload?.enabled },
        });
        return { data };
    },
    syncGoogleSheet: async (payload) => {
        const { data } = await client.axios.request({
            method: "POST",
            url: `/contests_editions/${payload?.id}/sync_sheet`,
        });
        return { data };
    },
    initializeContestsEditionPayment: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_editions",
            url: `/contests_editions/${payload?.contestsEditionId}/pay`,
            body: payload,
            method: "POST",
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map